import './index.less'
import { copyString, isiOS } from "@utils/index.js"

(function SocialSharePopup() {
	$(function () {
		const $socialSharePopup = $('.social-share-popup');
		if ($socialSharePopup.length == 0) {
			return;
		}

		// 页面标题
		let pageTitle = $("meta[property='og:title']").attr('content');

		/**
		 * 获取当前页面分享链接
		 * @param {string} type: 社交平台
		 * @returns {string}
		 */
		function getShareUrl(type) {
			let url;
			const currPage = window.location.href;
			const updateTime = Date.now();
			if (currPage.indexOf("?") !== -1) {
				url = `${currPage}&utm_source=${type}&utm_medium=organic&utm_campaign=${pageTitle}&t=${updateTime}`;
			} else {
				url = `${currPage}?utm_source=${type}&utm_medium=organic&utm_campaign=${pageTitle}&t=${updateTime}`;
			}
			return url;
		}
		function getEncodeShareUrl(type) {
			let url;
			const currPage = window.location.href;
			const updateTime = Date.now();
			if (currPage.indexOf("?") !== -1) {
				url = `${currPage}&utm_source=${type}&utm_medium=organic&utm_campaign=${encodeURIComponent(pageTitle)}&t=${updateTime}`;
			} else {
				url = `${currPage}?utm_source=${type}&utm_medium=organic&utm_campaign=${encodeURIComponent(pageTitle)}&t=${updateTime}`;
			}
			return url;
		}

		function openWindows(url) {
			window.open(
				url,
				'单独窗口',
				'height=300,width=600,top=30,left=20,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no'
			);
		}

		// 各社交平台分享插件调用
		function getSocialShareAPI(type, content) {
			let url = '';
			let pageShareUrl = getShareUrl(type);
			switch (type) {
				case 'facebook':
					url = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(pageShareUrl);
					break;
				case 'twitter':
					url = `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(pageShareUrl)}&ref_src=${encodeURIComponent('twsrc^tfw|twcamp^buttonembed|twterm^share|twgr^')}&text=${encodeURIComponent(content)}&url=${encodeURIComponent(`${pageShareUrl}`)}`;
					break;
				case 'whatsapp':
					url = `https://api.whatsapp.com/send?text=${content} ${encodeURIComponent(pageShareUrl)}`;
					break;
				case 'line':
					url = `http://line.me/R/msg/text/?${encodeURIComponent(content)} ${pageShareUrl}`
					break;
				case 'telegram':
					url = `https://t.me/share/url?url=${encodeURIComponent(`${pageShareUrl}`)}&text=${content}`;
					break;
				default:
					url = '';
					break;
			}
			return url;
		}

		let $popupDialogWrapper = $('.social-share-popup .dialog-wrapper');
		let insSuccessTxt = $popupDialogWrapper.data('ins-success-txt');
		let copySuccessTxt = $popupDialogWrapper.data('copy-success-txt');

		/**
		 * 社交分享方法调用
		 * @param {string} type: 社交平台
		 */
		function socialShareFunc(type) {
			let currPageShareUrl = getEncodeShareUrl(type);
			if (type == 'copy-link') {
				// 复制链接
				copyString(currPageShareUrl, () => {
					pushSuccessMessage(copySuccessTxt);
				})
			} else if (type === 'instagram') {
				// 复制链接并跳转
				copyString(currPageShareUrl, () => {
					pushSuccessMessage(insSuccessTxt)

					setTimeout(() => {
						window.open('https://www.instagram.com/', '_blank');
					}, 3000)
				})
			} else {
				// 其他平台 拉起对应API
				let shareAPIUrl = getSocialShareAPI(type, pageTitle);
				openWindows(shareAPIUrl);
			}
		}

		// 数据埋码
		function GAEvent(params) {
			window.dataLayer.push({ event_parameters: null });
			window.dataLayer.push({
				event: 'ga4Event',
				event_name: 'activity_page_user_clicks',
				event_parameters: {
					current_page: window.location.href, // current page url,
					module: 'Social Share',
					...params,
				},
			});
		}

		$('.social-share-popup .social-item').click(function (e) {
			let type = $(this).data('type');
			const title = $(this).find('p').text().trim() || '';
			if (type !== 'refer-a-friend') {
				socialShareFunc(type);
				// GA埋码
				GAEvent({ position: title })
			} else {
				e.preventDefault();

				// GA埋码
				GAEvent({ position: title });

				const link = $(this).find('a').attr('href');
				isiOS() ? (window.location.href = link) : window.open(link, '_blank');
			}
		});

		const $popupWrapper = $('.social-share-popup .dialog-wrapper');
		$('.social-share-popup .page-share-icon').click(function () {
			$popupWrapper.show();
			document.body.style.overflow = 'hidden'
			// GA埋码
			GAEvent();
		})

		$('.social-share-popup .icon-close,.social-share-popup .overlay').click(function () {
			$popupWrapper.hide();
			document.body.style.overflow = ''
		})

	})
})()
